export default {
  historyFields: [
    {
      key: 'event',
      label: 'Статус',
      sortable: true
    },
    {
      key: 'whodunnit',
      label: 'Автор',
      sortable: true
    },
    {
      key: 'createdAt',
      label: 'Дата и время',
      sortable: true
    }
  ],
  linkAddFields: [
    {
      key: 'addedBy',
      label: 'Добавил',
      sortable: true
    },
    {
      key: 'date',
      label: 'Дата',
      sortable: true
    },
    {
      key: 'url',
      label: 'Ссылка'
    },
    {
      key: 'comment',
      label: 'Комментарий'
    },
    {
      key: 'btn',
      label: ''
    }
  ]
};
